import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ButtonToolbar, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { clearFields, Field, reduxForm } from 'redux-form';
import SmartButton from '../../../shared/components/SmartButton';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';

const SelectorCourseSeriesModal = (props) => {
  const {
    t,
    isOpen,
    toggle,
    onSelection,
    schoolTerm,
    data,
    dispatch,
    cyclesClosure,
  } = props;
  const [selectedCourse, setSelectionCourse] = useState({});
  const [steps, setSteps] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [selectedStep, setSelectedStep] = useState({});
  const [selectedCycle, setSelectedCycle] = useState({});

  const buildCycles = () => {
    if (selectedCourse.id && selectedStep.id) {
      const listOfCycles = [];
      const cyclesClosureRegistered = cyclesClosure.filter(
        (item) =>
          item.course.id === selectedCourse.id &&
          item.courseStep.id === selectedStep.id
      );
      for (let i = 1; i <= selectedStep.cycleQuantity; i += 1) {
        listOfCycles.push({ value: i, label: `${i}º` });
      }
      if (cyclesClosureRegistered.length) {
        cyclesClosureRegistered.forEach((item) => {
          const index = listOfCycles.findIndex(
            (cycle) => cycle.value === item.cycleNumber
          );
          listOfCycles.splice(index, 1);
        });
      }
      setCycles(listOfCycles);
    }
  };

  const changeStepsByCourse = () => {
    if (selectedCourse.value) {
      const updatedSteps = data.find(
        (course) => course.id === selectedCourse.id
      );
      setSteps(updatedSteps.steps);
    }
  };

  const changeSelectedCycle = (value) => {
    setSelectedCycle(value);
  };

  const clearCycleField = () => {
    changeSelectedCycle({});
    setCycles([]);
    dispatch(
      clearFields('SelectorCourseSeriesModal', true, true, ...['cycle'])
    );
  };

  const changeSelectedStep = (value) => {
    clearCycleField();
    setSelectedStep({ ...value });
  };

  const clearCourseStepField = () => {
    changeSelectedStep({});
    dispatch(
      clearFields('SelectorCourseSeriesModal', true, true, ...['courseStep'])
    );
  };

  const changeSelectedCourse = (value) => {
    clearCourseStepField();
    clearCycleField();
    setSelectionCourse(value);
  };

  useEffect(() => {
    changeStepsByCourse();
  }, [selectedCourse]);

  useEffect(() => {
    buildCycles();
  }, [selectedStep]);

  return (
    <Modal isOpen={isOpen} className="selector-course-series-modal">
      <ModalHeader className="header">
        <span className="title">{t('general.new-cycle-closing')}</span>
      </ModalHeader>
      <ModalBody>
        <form className="theme-light form mt-2" onSubmit={onSelection}>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.school-term')}
            </span>
            <div className="form_form-group-field">
              <span>{schoolTerm.name}</span>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.course')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="course"
                component={SelectVirtualized}
                options={data}
                isClearable={false}
                onChange={(value) => changeSelectedCourse(value)}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.year-level')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="courseStep"
                component={SelectVirtualized}
                options={steps}
                isClearable={false}
                onChange={(value) => changeSelectedStep(value)}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.cycle')}</span>
            <div className="form_form-group-field">
              <Field
                name="cycle"
                component={SelectVirtualized}
                options={cycles}
                isClearable={false}
                onChange={(value) => changeSelectedCycle(value)}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <ButtonToolbar className="modal__footer">
            <SmartButton
              color="danger"
              label={t('general.cancel')}
              onClick={toggle}
            />
            <SmartButton
              label={t('general.confirm')}
              color="primary"
              disabled={
                !selectedCourse.value ||
                !selectedStep.value ||
                !selectedCycle.value
              }
              onClick={() =>
                onSelection({
                  course: selectedCourse,
                  courseStep: selectedStep,
                  cycleNumber: selectedCycle,
                  cycleClosed: false,
                  schoolTerm,
                })
              }
            />
          </ButtonToolbar>
        </form>
      </ModalBody>
    </Modal>
  );
};

SelectorCourseSeriesModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSelection: PropTypes.func.isRequired,
  schoolTerm: PropTypes.shape(PropTypes.shape).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  cyclesClosure: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
};

export default reduxForm({
  form: 'SelectorCourseSeriesModal',
})(withTranslation('common')(SelectorCourseSeriesModal));
